import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Attachment16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_269)'>
      <path
        d='M2.7421 9.10577L9.10589 2.7418C10.1798 1.66785 11.921 1.66786 12.995 2.7418C14.0689 3.81574 14.0689 5.55694 12.995 6.63088L14.0556 7.69154C15.7154 6.03182 15.7154 3.34086 14.0556 1.68114C12.3959 0.021408 9.70496 0.0214087 8.04523 1.68114L1.68144 8.04511C0.0217136 9.70484 0.0217134 12.3958 1.68144 14.0555C3.34117 15.7152 6.03212 15.7152 7.69185 14.0555L11.7577 9.98961C12.734 9.0133 12.734 7.43039 11.7577 6.45408C10.7813 5.47777 9.19843 5.47777 8.22212 6.45408L3.8027 10.8735L4.86336 11.9342L9.28278 7.51474C9.67331 7.12421 10.3065 7.12421 10.697 7.51474C11.0875 7.90526 11.0875 8.53843 10.697 8.92895L6.63119 12.9949C5.55725 14.0688 3.81604 14.0688 2.7421 12.9949C1.66816 11.9209 1.66816 10.1797 2.7421 9.10577Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_269'>
        <rect
          width='16'
          height='16'
          fill='white'
          transform='translate(16 16) rotate(-180)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Attachment16.displayName = 'Attachment16';
export default Attachment16;
